import BaseDataProcessor from './baseDataProcessor';

export default class FastingDataProcessor extends BaseDataProcessor {
  constructor(apiStatisticsData, interval) {
    super();

    this.apiStatisticsData = apiStatisticsData;
    this.interval = interval;
  }

  get apiData() {
    return this.apiStatisticsData;
  }

  get data() {
    if (this.apiStatisticsData) {
      const { full, forMeal, membersCount } = this.apiStatisticsData;
      return [
        this.interval !== 'day' ? { primaryText: full + forMeal, secondaryText: 'days of fasting' } : null,
        { primaryText: membersCount, secondaryText: 'members contributed' }
      ].filter(item => item);
    } else {
      return [];
    }
  }

  get chartData() {
    if (this.apiStatisticsData) {
      const { full, forMeal } = this.apiStatisticsData;

      return [
        full > 0 ? { x: `${full} Full fasting`, y: full } : null,
        forMeal > 0 ? { x: `${forMeal} Fasting for a meal`, y: forMeal } : null
      ].filter(item => item)
    } else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/dataProcessors/fastingDataProcessor.js